// extracted by mini-css-extract-plugin
export var activeNavLink = "toc-module--activeNavLink--b4f16";
export var container = "toc-module--container--fc674";
export var nav = "toc-module--nav--18c2c";
export var navLink = "toc-module--navLink--90f11";
export var navLinkXs = "toc-module--navLinkXs--b3b0b";
export var navList = "toc-module--navList--ddd6c";
export var subTocItem = "toc-module--subTocItem--c595e";